import { Material } from '@core/model/Material.model';
import { ProdWarning } from './prodWarning.model';
import { DimensionModel } from '@core/model/dimension.model';
import { LuzCapaInfo } from './LuzCapaInfo.model';
import { ModelInfo } from './modelInfo.model';
import { lock } from '@core/model/lock.model';
import { CerradurasAdicionalesModel } from './cerradurasAdicionales.model';

interface AccList {
    ItemId: string,
    ItemName: string,
    Type: number
 }

 interface ProcessList {
    Process: string,
    UrlImage: string
    OnlyQuotProcess: boolean;
 }

 /*interface CerradurasAdicionales {
    Producto: string,
    Codigo: number,
    Identificador: number,
    NumLuz: number,
    Opcional: boolean,
    Posicion: string,
    Cantidad: number
 }*/

export class PrefaReglasInfo extends ModelInfo {
    vListaConfig: DimensionModel[];
    vListaAcabados: DimensionModel[];
    vListaProcesos: ProcessList[];
    vListaAccesorios: AccList[];
    vListaAccSinHalad: AccList[];
    vListaLuzCapa: LuzCapaInfo[];
    vListaCedazos: LuzCapaInfo[];
    vConfiguracion: string;
    vAlias: string;
    vListaCerraduras: lock[];
    vListaCerradurasAdicionales: CerradurasAdicionalesModel[];
    vProceso: string;
    vTamano: string;
    vAcabado: string;
    vCerradura: string;
    vAutomatismoReq: boolean;
    vCerraduraReq: boolean;
    vManipulaCerradura: string;
    vContramarco: boolean;
    vTipoContramarco: string;
    vGuarnicion: boolean;
    vTipoGuarnicion: string;
    vRampa: number;
    vRodines: string;
    vCedazo: string;
    vBoolCedazo: boolean;
    vPosicionCedazo: string;
    vSeguroCorredizo: boolean;
    vCantVias: number;
    vBarraRefuerzo: boolean;
    vPerfilCedazo: string;
    vPerfilReforzado: boolean;
    vEnvidriador: string;
    vPerfilVertical: boolean;
    vBisagra: string;
    vAnclaje: string;
    vBarraTensora: string;
    vAcabadoBisagra: string;
    vAcabadoAnclaje: string;
    vAcabadoHaladera: string;
    // vDrenaje: boolean;
    // vPuntas: boolean;
    // vHuecos: boolean;

    constructor() {
    super();
    this.vListaConfig = [];
    this.vListaLuzCapa = [];
    this.vListaCedazos = [];
    this.vListaProcesos = [];
    this.vListaAccesorios = [];
    this.vListaAccSinHalad = [];
    this.vConfiguracion = '';
    this.vAlias = '';
    this.vListaCerraduras = [];
    this.vListaCerradurasAdicionales = [];
    this.vProceso = '';
    this.vAcabado = '';
    this.vTamano = '';
    this.vCerradura = '';
    this.vAutomatismoReq = false;
    this.vCerraduraReq = true;
    this.vManipulaCerradura = '';
    this.vContramarco = true;
    this.vTipoContramarco = '';
    this.vGuarnicion = true;
    this.vTipoGuarnicion = '';
    this.vRampa = 1;
    this.vRodines = '';
    this.vCedazo = '';
    this.vBoolCedazo = false;
    this.vPosicionCedazo = '';
    this.vSeguroCorredizo = false;
    this.vCantVias = 3;
    this.vBarraRefuerzo = false;
    this.vPerfilCedazo = '';
    this.vPerfilReforzado = true;
    this.vEnvidriador = '';
    this.vPerfilVertical = false;
    this.vBisagra = '';
    this.vAnclaje = '';
    this.vBarraTensora = '';
    this.vAcabadoBisagra = '';
    this.vAcabadoAnclaje = '';
    this.vAcabadoHaladera = '';
    // this.vDrenaje = false;
    // this.vPuntas = false;
    // this.vHuecos = false;
    }

    

    calcCerradurasAdic(){

    }
}
